import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchWithAuth } from '../utils/fetchWithAuth'
import Overlay from './Overlay'
import MessageBox from './MessageBox'
import VehicleUploadModal from './VehicleUploadModal'
import { EUROPEAN_COUNTRY_CODES } from '../constants/europeanCountries'
import {
  modalPrimaryButtonStyle,
  modalSecondaryButtonStyle,
  primaryButtonStyle
} from '../styles/buttonStyles'

const fileIcon = require('../assets/images/icons/upload.png')

const iconFilter =
  'brightness(0) saturate(100%) invert(87%) sepia(16%) saturate(560%) hue-rotate(90deg)'

const fields = [
  ['name', 'vehicle_name'],
  ['licensePlate', 'vehicle_license_plate'],
  ['confirmLicensePlate', 'vehicle_license_plate_confirm'],
  ['vin', 'vehicle_vin'],
  ['brand', 'vehicle_brand'],
  ['model', 'vehicle_model'],
  ['variantType', 'vehicle_type'],
  ['vehicleType', 'vehicle_class'],
  ['category', 'vehicle_category'],
  ['fuelType', 'vehicle_fuel_type'],
  ['engineCapacity', 'vehicle_engine_capacity'],
  ['power', 'vehicle_power'],
  ['transmission', 'vehicle_transmission'],
  ['color', 'vehicle_color'],
  ['emissionsCo2', 'vehicle_emissions_co2'],
  ['consumption', 'vehicle_consumption'],
  ['emissionClass', 'vehicle_emission_class'],
  ['year', 'vehicle_year'],
  ['stkDate', 'vehicle_stk_date'],
  ['ekDate', 'vehicle_ek_date'],
  ['serviceDate', 'vehicle_service_date'],
  ['tiresAllSeason', 'vehicle_tires_all_season'],
  ['startDate', 'vehicle_start_date'],
  ['note', 'vehicle_note'],
  ['pzpDate', 'vehicle_pzp_date'],
  ['pzpFrequency', 'vehicle_pzp_frequency'],
  ['hasCasco', 'vehicle_has_casco'],
  ['cascoDate', 'vehicle_casco_date'],
  ['cascoFrequency', 'vehicle_casco_frequency'],
  ['registrationCountry', 'vehicle_registration_country'],
  ['usageType', 'vehicle_usage_type'],
]

const DATE_FIELDS = [
  'stkDate',
  'ekDate',
  'serviceDate',
  'startDate',
  'pzpDate',
  'cascoDate'
]

const INTEGER_FIELDS = [
  'engineCapacity',
  'power',
  'year'
]

const DECIMAL_FIELDS = [
  'emissionsCo2',
  'consumption'
]

const REQUIRED_FIELDS = [
  'name',
  'licensePlate',
  'confirmLicensePlate',
  'registrationCountry'
]

const formatForDateInput = (value) => {
  if (!value) return ''
  if (typeof value === 'string') {
    const normalized = value.trim()
    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return normalized

    const skMatch = normalized.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/)
    if (skMatch) {
      const [, day, month, year] = skMatch
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }

  const d = new Date(value)
  if (isNaN(d.getTime())) return ''
  return d.toISOString().split('T')[0]
}

const Row = ({ htmlFor, label, children, layout }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <label
      htmlFor={htmlFor}
      style={{
        width: layout.labelW,
        fontWeight: 700,
        fontSize: layout.labelFont
      }}
    >
      {label}
    </label>

    <div style={{ display: 'flex', width: layout.inputW }}>
      {children}
    </div>
  </div>
)

const VehicleAddModal = ({ open, onClose, onSaved }) => {
  const { t } = useTranslation()

  const getCountryLabel = (code) => {
    if (!code) return ''
    const name = t(code)
    const resolved = name && name !== code ? name : code
    return `${code} - ${resolved}`
  }

  const [vw, setVw] = useState(window.innerWidth)

  const [form, setForm] = useState({})
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)
  const [uploadOpen, setUploadOpen] = useState(false)

  const [requiredDialog, setRequiredDialog] = useState(false)
  const [pressedBtn, setPressedBtn] = useState(null)
  const [hoverBtn, setHoverBtn] = useState(null)

  let layout = {}

  if (vw >= 1920) {
    layout = { labelW: 300, inputW: 320, inputH: 20, labelFont: 15, inputFont: 14, rowGap: 4 }
  } else if (vw >= 1366) {
    layout = { labelW: 260, inputW: 280, inputH: 18, labelFont: 14, inputFont: 13, rowGap: 3 }
  } else {
    layout = { labelW: 220, inputW: 240, inputH: 18, labelFont: 13, inputFont: 12, rowGap: 3 }
  }

const modalMaxWidth =
    vw >= 2800 ? '38vw' : vw >= 2600 ? '47.5vw' :  vw >= 2400 ? '51vw' :  vw >= 1920 ? '68vw' : vw >= 1366 ? '75vw' : '66vw'

const modalMaxHeight =
  vw >= 1920 ? '85vh' : '95vh'

const modalTitleFontSize =
  vw >= 1920 ? 24 :
  vw >= 1366 ? 24 :
  18

  const inputStyle = {
    height: layout.inputH,
    fontSize: layout.inputFont,
    padding: '6px 10px',
    borderRadius: 6,
    border: '1px solid #999',
    width: '100%'
  }

  useEffect(() => {
    const handleResize = () => setVw(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

useEffect(() => {
  const handleResize = () => setVw(window.innerWidth)
  window.addEventListener('resize', handleResize)
  return () => window.removeEventListener('resize', handleResize)
}, [])

useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && open && !uploadOpen) {
      onClose()
    }
  }

  window.addEventListener('keydown', handleKeyDown)
  return () => window.removeEventListener('keydown', handleKeyDown)
}, [open, onClose, uploadOpen])

useEffect(() => {
  if (!open) return
setForm({
  registrationCountry: 'SK',
  hasCasco: false,
  usageType: 'sukromne'
})
  setErrors({})
  setMessage(null)
  setRequiredDialog(false)
}, [open])

const validate = () => {
  const newErrors = {}

  // 1. mismatch presuň SEM (hore)
  if (
    form.licensePlate &&
    form.confirmLicensePlate &&
    form.licensePlate.toUpperCase() !== form.confirmLicensePlate.toUpperCase()
  ) {
    newErrors.confirmLicensePlate = true

    setErrors(newErrors)
    setRequiredDialog(false)
    setMessage({ message: t('vehicle_license_plate_missmatch'), type: 'error' })
    return false
  }

  // 2. required nechaj POD tým
  REQUIRED_FIELDS.forEach(field => {
    if (!form[field] || String(form[field]).trim() === '') {
      newErrors[field] = true
    }
  })

  setErrors(newErrors)

  if (Object.keys(newErrors).length > 0) {
    setRequiredDialog(true)
    return false
  }

  return true
}

  const mid = Math.ceil(fields.length / 2)
  const column1 = fields.slice(0, mid)
  const column2 = fields.slice(mid)

  const saveVehicle = async () => {

    if (!validate()) return

    const payload = {
      ...form,
      ...(form.hasCasco === false ? { cascoDate: null } : {}),
      ...Object.fromEntries(
        DATE_FIELDS.map((key) => [
          key,
          form[key] ? formatForDateInput(form[key]) || null : null
        ])
      )
    }

    try {
      setLoading(true)

      const res = await fetchWithAuth(`/vehicle`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })

      if (!res.ok) {
        let backendError = null

        try {
          backendError = await res.json()
        } catch {
          backendError = null
        }

        if (
          res.status === 409 &&
          (backendError?.field === 'vin' || backendError?.errorCode === 'vehicle_duplicate_vin')
        ) {
          setMessage({ message: t('vehicle_duplicate_vin'), type: 'error' })
          return
        }

        if (
          res.status === 409 &&
          (
            backendError?.field === 'licensePlate' ||
            backendError?.errorCode === 'vehicle_duplicate_plate'
          )
        ) {
          setMessage({ message: t('vehicle_duplicate_plate'), type: 'error' })
          return
        }

        setMessage({ message: backendError?.message || t('vehicle_save_failed'), type: 'error' })
        return
      }

      const created = await res.json().catch(() => payload)

      setMessage({ message: t('SAVED'), type: 'success' })
      onSaved?.(created)
      onClose()

    } catch {
      setMessage({ message: t('CONNECTION_ERROR'), type: 'error' })
    } finally {
      setLoading(false)
    }
  }

  if (!open) return null

  const renderField = ([key, labelKey]) => {

    const isDateField = DATE_FIELDS.includes(key)

    const errorStyle = errors[key]
      ? { background: 'rgba(255,0,0,0.1)', border: '1px solid #c62828' }
      : { background: '#fff' }

    return (
      <Row key={key} htmlFor={key} label={t(labelKey)} layout={layout}>

        {key === 'note' ? (
          <textarea
            id={key}
            value={form[key] || ''}
            onChange={e =>
              setForm(prev => ({
                ...prev,
                [key]: e.target.value === '' ? null : e.target.value
              }))
            }
            rows={2}
            style={{ ...inputStyle, ...errorStyle, resize: 'vertical' }}
          />
) : key === 'usageType' ? (
  <select
    id={key}
    value={form[key] ?? 'sukromne'}
    onChange={e => {
      setForm(prev => ({ ...prev, [key]: e.target.value }))
      setErrors(prev => ({ ...prev, [key]: false }))
    }}
    style={{
      ...inputStyle,
      ...errorStyle,
      height: 32
    }}
  >
    <option value="sukromne">{t('vehicle_usage_type_private')}</option>
    <option value="firemne">{t('vehicle_usage_type_company')}</option>
  </select>
) : key === 'registrationCountry' ? (
  <select
    id={key}
    value={form[key] ?? 'SK'}
    onChange={e => {
      setForm(prev => ({ ...prev, [key]: e.target.value }))
      setErrors(prev => ({ ...prev, registrationCountry: false }))
    }}
    style={{
      width: '100%',
      height: 32,
      borderRadius: 6,
      border: errors.registrationCountry ? '1px solid #c33' : '1px solid #999',
      backgroundColor: errors.registrationCountry ? '#f6caca' : '#ffffff',
      padding: '0 8px'
    }}
  >

    {['SK', ...EUROPEAN_COUNTRY_CODES.filter(c => c !== 'SK')].map(code => (
      <option
        key={code}
        value={code}
        style={{ backgroundColor: '#ffffff', color: '#000' }}
      >
        {getCountryLabel(code)}
      </option>
    ))}
  </select>
) : key === 'tiresAllSeason' ? (
  <select
    id={key}
    value={form[key] === true ? 'true' : 'false'}
    onChange={e => {
      setForm(prev => ({
        ...prev,
        [key]: e.target.value === 'true'
      }))
      setErrors(prev => ({ ...prev, [key]: false }))
    }}
    style={{
      ...inputStyle,
      ...errorStyle,
      height: 32
    }}
  >
    <option value="true">{t('dropdown_yes')}</option>
    <option value="false">{t('dropdown_no')}</option>
  </select>

) : key === 'pzpFrequency' ? (
  <select
    id={key}
    value={form[key] ?? ''}
    onChange={e => {
      setForm(prev => ({ ...prev, [key]: Number(e.target.value) }))
      setErrors(prev => ({ ...prev, [key]: false }))
    }}
    style={{
      ...inputStyle,
      ...errorStyle,
      height: 32
    }}
  >
    <option value="">-</option>
    <option value={1}>{t('vehicle_payment_yearly')}</option>
    <option value={2}>{t('vehicle_payment_halfyear')}</option>
    <option value={4}>{t('vehicle_payment_quarterly')}</option>
  </select>
) : key === 'hasCasco' ? (
  <select
    id={key}
    value={form[key] === true ? 'true' : 'false'}
    onChange={e => {
      const value = e.target.value === 'true'
      setForm(prev => ({
        ...prev,
        [key]: value,
        ...(value ? {} : { cascoDate: null, cascoFrequency: null })
      }))
      setErrors(prev => ({ ...prev, [key]: false }))
    }}
    style={{
      ...inputStyle,
      ...errorStyle,
      height: 32
    }}
  >
    <option value="true">{t('dropdown_yes')}</option>
    <option value="false">{t('dropdown_no')}</option>
  </select>
) : key === 'cascoFrequency' ? (
  <select
    id={key}
    value={form[key] ?? ''}
    disabled={form.hasCasco === false}
    onChange={e => {
      setForm(prev => ({ ...prev, [key]: Number(e.target.value) }))
      setErrors(prev => ({ ...prev, [key]: false }))
    }}
style={{
  ...inputStyle,
  ...errorStyle,
  height: 32,
  ...(form.hasCasco === false
    ? { background: '#ddd', cursor: 'not-allowed' }
    : {})
}}
  >
    <option value="">-</option>
    <option value={1}>{t('vehicle_payment_yearly')}</option>
    <option value={2}>{t('vehicle_payment_halfyear')}</option>
    <option value={4}>{t('vehicle_payment_quarterly')}</option>
  </select>
) : (
<input
  id={key}
  type={isDateField ? 'date' : 'text'}
  value={
    isDateField
      ? formatForDateInput(form[key])
      : (form[key] || '')
  }
disabled={key === 'cascoDate' && form.hasCasco === false}
readOnly={key === 'cascoDate' && form.hasCasco === false}
onChange={e => {
  let val = e.target.value

  // CAPITALIZE pre ŠPZ + VIN
  if (
    key === 'licensePlate' ||
    key === 'confirmLicensePlate' ||
    key === 'vin'
  ) {
    val = val.toUpperCase()
  }

    if (INTEGER_FIELDS.includes(key)) {

      if (key === 'year') {
        if (!/^\d{0,4}$/.test(val)) {
          return
        }
      } else {
        if (!/^\d*$/.test(val)) {
          return
        }
      }

    }

    if (DECIMAL_FIELDS.includes(key)) {
      val = val.replace(',', '.')
      if (!/^\d*\.?\d{0,2}$/.test(val)) {
        return
      }
    }

    setForm(prev => ({ ...prev, [key]: val }))
  }}
  style={{
  ...inputStyle,
  ...errorStyle,
  ...(key === 'cascoDate' && form.hasCasco === false
    ? { background: '#ddd', cursor: 'not-allowed' }
    : {})
}}
/>
        )}

      </Row>
    )
  }

  return (
    <>
      <Overlay open={loading} zIndex={4000} backdropOpacity={0.75} />

      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 3100,
          padding: 20
        }}
      >
        <div
          onClick={e => e.stopPropagation()}
          style={{
            background: '#ededed',
            padding: '5px 30px 10px 30px',
            border: '2px solid #107c6b',
            borderRadius: 14,
            boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
            width: '100%',
            maxWidth: modalMaxWidth,
            maxHeight: modalMaxHeight,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
<div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 20
  }}
>
  <h3 style={{ fontSize: modalTitleFontSize, margin: 0 }}>
    {t('vehicle_add_title')}
  </h3>

  {requiredDialog && (
    <MessageBox
      message={t('vehicle_required_name')}
      type="error"
    />
  )}

  {message && (
    <MessageBox
      message={message.message}
      type={message.type}
    />
  )}
</div>
          <div
            style={{
              display: 'flex',
              gap: 60,
              overflowY: 'auto',
              flex: 1
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: layout.rowGap }}>
              {column1.map(renderField)}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: layout.rowGap }}>
              {column2.map(renderField)}
            </div>
          </div>

<div
  style={{
    display: 'flex',
    gap: 12,
    marginTop: 15,
    justifyContent: 'center'
  }}
>

  {/* FILE */}
  <button
style={{
  ...primaryButtonStyle(
    pressedBtn,
    'file',
    hoverBtn === 'file'
  ),
  height: 40,
  borderRadius: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  boxShadow:
    pressedBtn === 'file'
      ? 'inset 0 2px 4px rgba(0,0,0,0.5)'
      : '0 4px 10px rgba(0,0,0,0.35)',

  transform:
    pressedBtn === 'file'
      ? 'translateY(1px)'
      : 'translateY(0)'
}}
    onMouseEnter={() => setHoverBtn('file')}
    onMouseLeave={() => {
      setHoverBtn(null)
      setPressedBtn(null)
    }}
    onMouseDown={() => setPressedBtn('file')}
    onMouseUp={() => setPressedBtn(null)}
    onClick={() => {
      setUploadOpen(true)
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <img
        src={fileIcon}
        alt="file"
        style={{
          height: 20,
          objectFit: 'contain',
          filter: iconFilter
        }}
      />
      {t('TRIPLOG.VEHICLES.BUTTON_FILE')}
    </div>
  </button>

  {/* SAVE */}
  <button
    style={modalPrimaryButtonStyle(
      pressedBtn,
      'saveVehicle',
      hoverBtn === 'saveVehicle'
    )}
    onMouseEnter={() => setHoverBtn('saveVehicle')}
    onMouseLeave={() => {
      setHoverBtn(null)
      setPressedBtn(null)
    }}
    onMouseDown={() => setPressedBtn('saveVehicle')}
    onMouseUp={() => setPressedBtn(null)}
    onClick={saveVehicle}
  >
    {t('SAVE')}
  </button>

  {/* CANCEL */}
  <button
    style={modalSecondaryButtonStyle(
      pressedBtn,
      'cancelVehicle',
      hoverBtn === 'cancelVehicle'
    )}
    onMouseEnter={() => setHoverBtn('cancelVehicle')}
    onMouseLeave={() => {
      setHoverBtn(null)
      setPressedBtn(null)
    }}
    onMouseDown={() => setPressedBtn('cancelVehicle')}
    onMouseUp={() => setPressedBtn(null)}
    onClick={onClose}
  >
    {t('CANCEL')}
  </button>

</div>
        </div>
      </div>
<VehicleUploadModal
  open={uploadOpen}
  onClose={() => setUploadOpen(false)}
  onSaved={() => {
    setUploadOpen(false)
    onSaved?.()
  }}
/>
    </>
  )
}

export default VehicleAddModal